module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "usuario"
    }
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.nome),
      expression: "usuario.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    class: {
      'has-error': _vm.errors.first('nome')
    },
    attrs: {
      "disabled": true,
      "id": "nome",
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O Nome do usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), (_vm.usuario.tipo === 'ENTIDADE') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.cpf),
      expression: "usuario.cpf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    class: {
      'has-error': _vm.errors.first('cpf')
    },
    attrs: {
      "disabled": true,
      "id": "cpf",
      "name": "cpf",
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "cpf", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O CPF é obrigatório para esse usuário')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('email')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    class: {
      'has-error': _vm.errors.first('email')
    },
    attrs: {
      "disabled": true,
      "id": "email",
      "name": "email",
      "minlength": "1",
      "maxlength": "255",
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O E-mail é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Situação do usuário:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "id": "btn-radios-2",
      "options": _vm.situacao_opcoes,
      "size": "xg",
      "name": "radio-btn-outline",
      "button-variant": "inline-primary",
      "buttons": ""
    },
    model: {
      value: (_vm.usuario.ativo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ativo", $$v)
      },
      expression: "usuario.ativo"
    }
  })], 1)], 1)])])]), _vm._v(" "), (this.$root.authorize('usuario-fundacao-atribuir-perfil')) ? _c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('fieldset', [_c('legend', [_vm._v("Perfis")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.table.items,
      "hover": _vm.hover,
      "fields": _vm.table.fields,
      "filter": _vm.filter,
      "current-page": _vm.table.currentPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Preencha o filtro acima!",
      "table-layout:": "",
      "fixed": "",
      "tbody-tr-class": _vm.formatarLinhas
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value == '1' ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "data_inicial",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "data_alteracao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "data_inativacao",
      fn: function(row) {
        return [_c('datepicker', {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          attrs: {
            "name": "data_inativar",
            "id": "data_inativar",
            "input-class": "form-control datepicker datapicker2",
            "language": _vm.$datePickerPtBR,
            "maxlength": "20",
            "use-utc": true,
            "placeholder": "__ /__ /____",
            "open-date": new Date(),
            "format": "dd/MM/yyyy"
          },
          on: {
            "input": function($event) {
              return _vm.alteradoPor(row.item)
            }
          },
          model: {
            value: (row.item.data_inativacao),
            callback: function($$v) {
              _vm.$set(row.item, "data_inativacao", $$v)
            },
            expression: "row.item.data_inativacao"
          }
        })]
      }
    }], null, false, 54454404)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal well well-sm",
    attrs: {
      "name": "novo_perfil"
    }
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Adicionar o perfil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: {
      'has-error': _vm.errors.first('perfil')
    }
  }, [_c('profiles', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "perfil",
      "propsProfile": _vm.perfil_novo.perfil
    },
    on: {
      "profileSelected": function($event) {
        _vm.perfil_novo.perfil = $event
      }
    },
    model: {
      value: (_vm.perfil_novo.perfil),
      callback: function($$v) {
        _vm.$set(_vm.perfil_novo, "perfil", $$v)
      },
      expression: "perfil_novo.perfil"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('perfil')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('data_inicial')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "data_inicial"
    }
  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data_inicial",
      "id": "data_inicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.perfil_novo.data_inicial),
      callback: function($$v) {
        _vm.$set(_vm.perfil_novo, "data_inicial", $$v)
      },
      expression: "perfil_novo.data_inicial"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('data_inicial')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "data_inativacao"
    }
  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "min": "2019-07-01",
      "max": "2020-12-31",
      "name": "data_inativacao",
      "id": "data_inativacao",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "open-date": new Date(),
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.perfil_novo.data_inativacao),
      callback: function($$v) {
        _vm.$set(_vm.perfil_novo, "data_inativacao", $$v)
      },
      expression: "perfil_novo.data_inativacao"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-3"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "disabled": !_vm.$root.authorize('perfil-atribuir-usuario')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.adicionaPerfil()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Incluir\n                      ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.concluirAlteracoes($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro do usuário: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("- Para "), _c('b', [_vm._v("Retirar")]), _vm._v(" um acesso concedido, atribua uma data final ao perfil desejado na lista acima. Informando uma data menor que a atual, o acesso será interrompido de imediato.")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "darkblue"
    }
  }, [_vm._v("- Para "), _c('b', [_vm._v("Conceder")]), _vm._v(" um acesso, basta escolher abaixo um perfil da lista, informar a data da concessão e opcionalmente uma data de término")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', [_vm._v("*Obs: A data 01/01/1900 é utilizada para identificar que o acesso em questão não tem vigência definida, portanto permanecerá ativo por tempo indeterminado.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55ab58c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/usuario/EditaUsuario.vue
// module id = 1903
// module chunks = 2